<template>
  <pn-tooltip
    :warning="warning"
    :solid="solid"
    :color="color"
    :hover-color="hoverColor"
    :position="ttPosition"
    :class="[{ padded }, `${className}`]"
    class="responsive-tooltip"
  >
    <slot></slot>
  </pn-tooltip>
</template>

<script>
export default {
  name: 'responsive-tooltip',
  props: {
    solid: Boolean,
    warning: Boolean,
    color: String,
    hoverColor: String,
    position: String,
    className: String,
    padded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSmallScreen: false
    }
  },
  computed: {
    ttPosition() {
      return this.position === 'right' && this.isSmallScreen
        ? 'bottom'
        : this.position
    }
  },
  mounted() {
    window.addEventListener('resize', this.onWindowResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize)
  },
  methods: {
    onWindowResize(e) {
      this.isSmallScreen = e.target.innerWidth < 1200
    }
  }
}
</script>

<style lang="scss">
.responsive-tooltip {
  .pn-help-tooltip-content {
    width: 19em;

    &.position-right {
      left: 1.5em;
    }

    &.position-left {
      right: 1.5em;
    }

    &.position-bottom {
      top: 3em;
    }

    &.position-top {
      bottom: 160%;
    }
  }

  &.padded {
    .pn-help-tooltip-content {
      &.position-right {
        left: 3em;
      }

      &.position-bottom {
        top: 4em;
      }
    }
  }
}

@media screen and (max-width: 50em) {
  .responsive-tooltip {
    &.padded {
      .pn-help-tooltip-content {
        &.position-bottom {
          left: -6.5em;

          &::before {
            left: unset;
            right: 8%;
          }
        }
      }
    }
  }
}
</style>
